import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-eligiblity-for-teacher-popup',
  templateUrl: './eligiblity-for-teacher-popup.component.html',
  styleUrls: ['./eligiblity-for-teacher-popup.component.scss']
})
export class EligiblityForTeacherPopupComponent implements OnInit {
  courseList: any[];
  filteredCourseList: any[];
  filteredListFcCode: any;
  fcCodeList: any;
  SessionFilterList: any;
  sessionList: any;
  eligiblityForm: FormGroup;
  filteredrequestTypeList: any;
  requestTypeList: any[];
  courseLevelList: any;
  filteredcourseLevelList: any;
  submitpayload: any;
  APIService: string;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  eligibilityList: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
  private dialogRef2: MatDialogRef<EligiblityForTeacherPopupComponent>,) {this.APIService = environment.serviceUrl;}
  dialogRef: MatDialogRef<any>;
  ngOnInit(): void {
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.eligiblityForm = this.fb.group({
      SrNo: new FormControl(''),
      SessionID: new FormControl('', [Validators.required]),
      Faculty: new FormControl('', [Validators.required]),
      CoCode: new FormControl('', [Validators.required]),
      Designation: new FormControl('', [Validators.required]),
      Experience: new FormControl('', [Validators.required]),
      Count: new FormControl(''),
      CoLevel: new FormControl('', [Validators.required]),
    })

    window.scroll(0, 0);
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
      console.log('this.data.selected',this.data.selected)
    } else if (this.data.key == "Delete") {
      this.prepopulationForDelete(this.data.selected);
      console.log('this.data.selected',this.data.selected)
    } else {
      // alert(this.data.key)
    }
    this.fetchFacultyCode();
    this.fetchSession();
    this.fetchRequestType();
    this.fetchCourseLevel();
    this.getTeacherEligibility();
  }

  fetchFacultyCode() {
    this.spinner.show()
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.fcCodeList = res.data;
        this.filteredListFcCode = this.fcCodeList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }
  getCourseData(id) {
    this.courseList = []
    this.filteredCourseList = []
    this.spinner.show();
    const payload = {};
    payload['CoFcCode'] = id;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  fetchSession() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide();
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
  fetchRequestType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'ReqTy';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.requestTypeList = res.data;
        this.filteredrequestTypeList = this.requestTypeList.slice();
      } else {
        this.requestTypeList = [];
        this.filteredrequestTypeList = this.requestTypeList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();

      })
  }

    fetchCourseLevel() {
    const payload = {};
    payload['CdType'] = 'COLVL';
    this.umsService.getCodeType(payload).subscribe(res => {
      if (res.status) {
        this.courseLevelList = res.data;
        this.filteredcourseLevelList = this.courseLevelList.slice();

      }
    })
  }

    submitMarkAsTouched() {
      if (this.eligiblityForm.invalid) {
        this.eligiblityForm.get('SessionID').markAsTouched();
        this.eligiblityForm.get('Faculty').markAsTouched();
        this.eligiblityForm.get('CoCode').markAsTouched();
        this.eligiblityForm.get('Designation').markAsTouched();
        this.eligiblityForm.get('Experience').markAsTouched();
        this.eligiblityForm.get('CoLevel').markAsTouched();
        return;
      } else {
        this.Submit();
      }
    }
  
    Submit() {
      this.spinner.show();
      this.submitpayload = this.eligiblityForm.value;
      let payload = {};
      // payload['SessionID'] = this.submitpayload.SessionID;
      // payload['Faculty'] = this.submitpayload.Faculty;
      // payload['CoCode'] = this.submitpayload.CoCode;
      // payload['Designation'] = this.submitpayload.Designation;
      // payload['Experience'] = this.submitpayload.Experience;
      // payload['CoLevel'] = this.submitpayload.CoLevel;
      //  payload['SrNo'] = this.submitpayload.SrNo;
      //   payload['Count'] = this.submitpayload.Count;
      console.log('this.submitpayload',this.submitpayload)
      this.umsService.addTeacherEligibility(this.submitpayload).subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            // this.dialogRef2.close();
          });
        } else {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.dialogRef2.close();
          });
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
    }
  
    updateMarkAsTouched() {
      if (this.eligiblityForm.invalid) {
        this.eligiblityForm.get('SessionID').markAsTouched();
        this.eligiblityForm.get('Faculty').markAsTouched();
        this.eligiblityForm.get('CoCode').markAsTouched();
        this.eligiblityForm.get('Designation').markAsTouched();
        this.eligiblityForm.get('Experience').markAsTouched();
        this.eligiblityForm.get('CoLevel').markAsTouched();
        return;
      } else {
        this.Update();
      }
    }
  
    Update() {
      this.spinner.show();
      this.submitpayload = this.eligiblityForm.value;
      // this.submitpayload['CoRgPrfx'] = this.preFixValue
      this.umsService.updateTeacherEligibility(this.submitpayload).subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        } else {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
    }
     prepopulation(id) {
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.eligiblityForm = this.fb.group({
      SrNo: new FormControl(id.SrNo),
      SessionID: new FormControl(id.SessionID, [Validators.required]),
      Faculty: new FormControl(id.Faculty, [Validators.required]),
      CoCode: new FormControl(id.CoCode, [Validators.required]),
      Designation: new FormControl(id.Designation, [Validators.required]),
      Experience: new FormControl(id.Experience, [Validators.required]),
      CoLevel: new FormControl(id.CoLevel, [Validators.required]),
      Count: new FormControl(id.Count),
    });
  }

    deletee(e, k) {
      if (e === 'true') {
        this.prepopulationForDelete(k);
      } else {
      }
    }
    openConformationModalBox() {
      let data = {}
      data['message'] = 'Are You Sure You Want To Delete This Record ?'
      data['title'] = 'Alert'
      data['icon'] = 'fa fa-question'
      this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        if (result == 'yes') {
          this.deletedata(this.eligiblityForm.value);
        }
      });
    }
  
    deletedata(id) {
      this.spinner.show();
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }), body: {
          SrNo: id.SrNo,
          SessionID: id.SessionID,
          Faculty: id.Faculty,
          CoCode: id.CoCode,
          Designation: id.Designation,
          Experience: id.Experience,
          CoLevel: id.CoLevel,
          Count: id.Count,
        },
      };
      this.httpClient.delete(this.APIService + '/supervisor/TeacherEligibility', options)
        .subscribe((s) => {
          this.spinner.hide();
          let cc = [];
          cc.push(s);
          let data = {}
          data['message'] = cc[0].message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            // this.ngOnInit();
            this.dialogRef2.close();
          });
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          let data = {}
          data['message'] = ERROR.error.message
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ngOnInit();
        });
  
    }
  
    prepopulationForDelete(id) {
    this.deleteButton = true;
    this.editButton = false;
    this.submitButton = false;
      this.eligiblityForm = this.fb.group({
      SrNo: new FormControl(id.SrNo),
      SessionID: new FormControl(id.SessionID, [Validators.required]),
      Faculty: new FormControl(id.Faculty, [Validators.required]),
      CoCode: new FormControl(id.CoCode, [Validators.required]),
      Designation: new FormControl(id.Designation, [Validators.required]),
      Experience: new FormControl(id.Experience, [Validators.required]),
      CoLevel: new FormControl(id.CoLevel, [Validators.required]),
      Count: new FormControl(id.Count),
    });
    }
    getTeacherEligibility() {
    this.spinner.show();
    const payload = {};
    this.umsService.searchTeacherEligibility(payload).subscribe(res => {
      this.spinner.hide();
      this.eligibilityList = res.data;
      // this.sortedData = [...this.courseList];
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.eligibilityList = [];
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
}
